module.exports = __webpack_public_path__ + "img/edit_form_remove.b459198a.svg";